import type { OwnerPrincipal, Permission } from "./types.ts";

export const ownerPermissions: Record<OwnerPrincipal["role"], Permission[]> = {
  owner: [
    "venue:manage",
    "branch:manage",
    "table:manage",
    "menu:manage",
    "social_rules:manage",
    "session_template:manage",
    "staff:manage",
    "roles:view",
    "roles:assign",
    "analytics:view",
    "incidents:view",
    "privacy:manage",
    "retention:manage",
  ],
  manager: [
    "branch:manage",
    "table:manage",
    "menu:manage",
    "session_template:manage",
    "staff:manage",
    "roles:view",
    "analytics:view",
    "incidents:view",
  ],
};

export function hasOwnerPermission(
  principal: Pick<OwnerPrincipal, "permissions"> | null | undefined,
  permission: Permission,
): boolean {
  return Boolean(principal?.permissions.includes(permission));
}
